import donateImage from "../../images/donate.jpeg"

export const donate = {
  "subtitle-de": "SPENDEN",
  "subtitle-ro": "DONEAZĂ",
  "header-de": "Du kannst uns per Überweisung unterstützen",
  "header-ro": "Ne puteți susține prin transfer bancar",
  text: "Pfingstkirche Agape Wien | AT35 3207 3000 0084 8226",
  image: donateImage,
  "caption-de": "Oder scanne diesen QR-Code über deine E-Banking App",
  "caption-ro": "Sau scanați acest cod QRfolosind aplicația dvs. de e-banking"
}